import {mapActions, mapGetters, mapMutations} from 'vuex';
import chatComponent from '@/components/features/chat-component/index.vue';
import retakingHistory from '@/components/features/home-work-retaking-history/index.vue';
import { seo } from '@/mixins/seo';

export default {
    name: 'home-work-check',
    mixins: [seo],
    components: {
        chatComponent,
        retakingHistory
    },
    created() {

        this.changeHeader({
            show: true,
            title: '',
            parentRoute: {name: 'courses-main', params: {item: this.$route.params.item}}
        })

        this.fetchItem({
            ...this.$route.params,
        }).then(() => {
            this.seo.title = this.currentItem.name + ' - ' + this.course.name;
            this.$emit('updateHead')
        })
    },

    mounted() {
        // land at the top after navigation/reload, not stuck at the page bottom
        this.$nextTick(() => {
            const app = document.querySelector('.app');
            if (app) app.scrollTop = 0;
            window.scrollTo(0, 0);
        });
    },

    computed: {
        ...mapGetters({
            isLoading: 'coursesHomeWork/isLoading',
            currentItem: 'coursesHomeWork/currentItem',
            course: 'courses/currentItem',
            routeFromInfo: 'coursesHomeWork/routeFromInfo',
        }),
        convertSecondsToMinutes() {
            if (!this.currentItem.duration) return 0
            return Math.ceil(this.currentItem.duration / 60)
        },

        hasPractic() {
            return this.currentItem.type === 'text'
        },

        materialsList() {

            let concatMaterials = []

            for (let module of this.course.modules.data) {
                concatMaterials = [...concatMaterials, ...module.materials.data]
            }
            return concatMaterials
        },

        nextActiveMaterial() {
            let currentSort = this.currentItem.sort,
                list = this.materialsList,
                activeMaterial = null;
            for (let item of list) {
                if (item.sort > currentSort) {
                    let typeMaterial = item.material === 'lesson' ? 'userLesson' : 'userHomeWork';
                    let status = item[typeMaterial].data.hasOwnProperty('id') ? item[typeMaterial].data.status : 'new';
                    if (status !== 'failed' && status !== 'locked' && status !== 'expired') {
                        activeMaterial = item;
                        break;
                    }
                }
            }

            return activeMaterial;
        }
    },
    methods: {
        ...mapActions({
            fetchItem: 'coursesHomeWork/GET_LIST_ITEM',
        }),
        ...mapMutations({
            changeHeader: 'coursesHomeWork/CHANGE_HEADER',
            setItem: 'coursesHomeWork/SET_ITEM',
            changeRouteFromInfo: 'coursesHomeWork/CHANGE_FROM_ROUTE_INFO',
        }),
        declensionWord(count, type) {
            let titles = [this.$t(`${type}1`), this.$t(`${type}2`), this.$t(`${type}3`)];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[(count % 100 > 4 && count % 100 < 20) ? 2 : cases[(count % 10 < 5) ? count % 10 : 5]];
        },
        navigateTo(route) {
            try {
                this.$router.push({
                    name: route, params: {
                        ...this.$route.params,
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },

        onNextMaterial() {
            let nextMaterial = this.nextActiveMaterial;
            if (!nextMaterial) return;

            const moduleSlug = this.course.modules.data.find(item => item.id === nextMaterial.moduleId).slug
            try {
                if (nextMaterial.material === 'lesson') {
                    this.$router.push({
                        name: 'courses-lesson-detail',
                        params: {
                            item: this.$route.params.item,
                            moduleSlug,
                            lessonSlug: nextMaterial.slug
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'home-work-rules',
                        params: {
                            item: this.$route.params.item,
                            moduleSlug,
                            testId: nextMaterial.slug
                        }
                    })
                }
            } catch (e) {
                console.log('');
            }
        },
        goBack() {
            this.$router.push({name: this.routeFromInfo.name, params: this.routeFromInfo.params});
        },
    },
    destroyed() {
        this.setItem(null);
        this.changeHeader({
            show: false,
            title: '',
            parentRoute: ''
        })
    }
}
